import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=44bd9f95"
import script from "./Packs.vue?vue&type=script&lang=ts"
export * from "./Packs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports